import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { useProgress } from '@react-three/drei';

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      boxStyle: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      loaderStyle: {
        position: 'absolute',
        color: `${COLORS.white} !important`,
      },
      percentStyle: {
        position: 'absolute',
        color: COLORS.black,
        fontFamily: theme.typography.fontFamily,
        fontSize: 20,
      },
    })
);

const Loader = (): JSX.Element => {
  const classes = useStyles();

  const all = useProgress();

  const { active, progress, errors, item, loaded, total } = all;

  // DefaultLoadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
  //   const progressPercent = Math.floor((itemsLoaded / itemsTotal) * 100);
  //   console.log('>>>>>>', progressPercent, itemsLoaded, itemsTotal);
  // };

  const progressPercent = Math.floor((loaded / total) * 100);

  // console.log('>>>>>>', progressPercent, progress);

  if (loaded) {
    return null;
  }

  return (
    <div className={classes.boxStyle}>
      <CircularProgress className={classes.loaderStyle} size={40} />
      {progressPercent > 0 && (
        <div className={classes.percentStyle}>{progressPercent + '%'}</div>
      )}
    </div>
  );
};

export default Loader;
